
const SystemSettingsTranslation = {
    _analyticalDashboardUrl: {
        pt_br: 'Url do dashboard analítico (Power BI)',
        en_us: 'Analytical dashboard url (Power BI)',
        es_es: 'URL del panel analítico (Power BI)'
    },

    _financialDashboardUrl: {
        pt_br: 'Url do dashboard financeiro (Power BI)',
        en_us: 'Financial dashboard url (Power BI)',
        es_es: 'Url del panel financiero (Power BI)'
    },

    _managementDashboardUrl: {
        pt_br: 'Url do dashboard gerencial (Power BI)',
        en_us: 'Management dashboard url (Power BI)',
        es_es: 'Url del panel de gestión (Power BI)'
    },

    _partnerPmsDataRefreshTimeInSeconds: {
        pt_br: 'Tempo de atualização dos dados no PMS parceiro (em segundos)',
        en_us: 'Time to update the data in the partner PMS (in seconds)',
        es_es: 'Tiempo necesario para actualizar los datos en el PMS asociado (en segundos)'
    },

    _partnerPmsDefault: {
        pt_br: 'Sistema PMS parceiro',
        en_us: 'Partner PMS System',
        es_es: 'Sistema PMS asociado'
    },

    _sendEmailUsername: {
        pt_br: 'Nome de usuário utilizado no envio de e-mails',
        en_us: 'Username used when sending emails',
        es_es: 'Nombre de usuario utilizado al enviar correos electrónicos'
    },

    _sendEmailEmail: {
        pt_br: 'E-mail utilizado no envio de e-mails',
        en_us: 'Email used to send emails',
        es_es: 'Correo electrónico utilizado para enviar correos electrónicos'
    },

    _sendEmailPassword: {
        pt_br: 'Senha utilizada para autenticação do e-mail no envio de e-mails',
        en_us: 'Password used for email authentication when sending emails',
        es_es: 'Contraseña utilizada para la autenticación de correo electrónico al enviar correos electrónicos'
    },

    _sendEmailSecurityLevel: {
        pt_br: 'Nível de segurança utilizado no envio de e-mails',
        en_us: 'Security level used when sending emails',
        es_es: 'Nivel de seguridad utilizado al enviar correos electrónicos'
    },

    _sendEmailProtocol: {
        pt_br: 'Protocolo utilizado no envio de e-mails',
        en_us: 'Protocol used to send emails',
        es_es: 'Protocolo utilizado para enviar correos electrónicos'
    },

    _sendEmailServer: {
        pt_br: 'Servidor de domínio utilizado no envio de e-mails',
        en_us: 'Domain server used for sending emails',
        es_es: 'Servidor de dominio utilizado para enviar correos electrónicos'
    },

    _sendEmailPort: {
        pt_br: 'Porta do servidor de domínio utilizado no envio de e-mails',
        en_us: 'Domain server port used to send emails',
        es_es: 'Puerto del servidor de dominio utilizado para enviar correos electrónicos'
    },

    _serviceOrderDataRefreshTimeInSeconds: {
        pt_br: 'Tempo de atualização das ordens de serviço (em segundos)',
        en_us: 'Service order update time (in seconds)',
        es_es: 'Tiempo de actualización de la orden de servicio (en segundos)'
    },

    _systemIcon: {
        pt_br: 'Ícone do sistema',
        en_us: 'System icon',
        es_es: 'Icono del sistema'
    },

    _systemLogo: {
        pt_br: 'Logo do sistema',
        en_us: 'System logo',
        es_es: 'Logotipo del sistema'
    },

    _systemVersion: {
        pt_br: 'Versão do sistema',
        en_us: 'System version',
        es_es: 'Versión del sistema'
    },

    _vacationCenterDashboardUrl: {
        pt_br: 'Url do dashboard da central de férias (Power BI)',
        en_us: 'Vacation center dashboard url (Power BI)',
        es_es: 'Url del panel del centro de vacaciones (Power BI)'
    },
}

export default SystemSettingsTranslation;